import '../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.constructor.mjs';
import '../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.filter.mjs';
import '../node_modules/.pnpm/core-js@3.37.0/node_modules/core-js/modules/esnext.iterator.find.mjs';
import { getKeyByFucCode } from '../utils.mjs';
import { FINANCIAL_CODE_DICTIONARY, FINANCIAL_NAME_MAP, 같이_선택되어야하는_기관_목록 } from './data.mjs';

function isDictName(value) {
  const found = !!Object.values(FINANCIAL_CODE_DICTIONARY).find(item => item.name === value);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof value === 'string' && !found) {
      // eslint-disable-next-line no-console
      console.log(`${value}는 현재 금융사명 목록에 존재하지 않습니다. 혹시 매칭이 필요하시다면 https://oss.fin.navercorp.com/common-fe/pie/issues 에 이슈로 남겨주세요!`);
      return false;
    }
  }
  return typeof value === 'string' && found;
}
function getOrgNameByFucCode(payOrgCode) {
  const key = getKeyByFucCode(payOrgCode);
  return FINANCIAL_CODE_DICTIONARY[key].name;
}
function preprocessRawText(rawText) {
  // 괄호 안의 내용은 제거 (중첩된 내용도 제거), 특수문자와 공백 일부 제거
  const result = rawText
  // .toUpperCase()
  .replace(/\(카드\)/g, '카드').replace(/\((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*\)/g, '').replace(/[\s(]/g, '').replace(/[_|-]/g, '');

  // `새마을금고` 또는 `산림조합`을 포함하는 경우 각각으로 매핑
  if (/새마을금고/g.test(result)) {
    return '새마을금고';
  }
  if (/산림조합/g.test(result)) {
    return '산림조합';
  }
  return result;
}

// 기관명 선처리 및 매핑
function convertRawName(rawName) {
  const preprocessedName = preprocessRawText(rawName);
  const nameMatched = FINANCIAL_NAME_MAP.get(preprocessedName);
  return nameMatched || preprocessedName;
}

// 이름에 중복이 있거나, 같이 선택되는 경우가 있어 array return
function getDictItemsByName(rawName) {
  function isSelectTogetherCompany(name) {
    return Object.keys(같이_선택되어야하는_기관_목록).includes(name);
  }
  const convertedName = convertRawName(rawName);
  const possibleNames = isSelectTogetherCompany(convertedName) ? 같이_선택되어야하는_기관_목록[convertedName] : [convertedName];
  return Object.values(FINANCIAL_CODE_DICTIONARY).filter(item => possibleNames.includes(item.name));
}
function getDictItemByType(candidates, type) {
  return candidates.find(candidate => candidate.type === type);
}
function filterDictItemsByType(candidates, type) {
  return candidates.filter(candidate => candidate.type === type);
}

export { convertRawName, filterDictItemsByType, getDictItemByType, getDictItemsByName, getOrgNameByFucCode, isDictName, preprocessRawText };
